/**
 * @generated SignedSource<<c4d5f7b2d9ca0b4a445e16177dfcd112>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationWebFetcherCreateScreenWebFetcherMutation$variables = {
  url: string;
};
export type IntegrationWebFetcherCreateScreenWebFetcherMutation$data = {
  readonly store: {
    readonly createIntegrationWebFetch: {
      readonly id: string;
    } | null;
  };
};
export type IntegrationWebFetcherCreateScreenWebFetcherMutation = {
  response: IntegrationWebFetcherCreateScreenWebFetcherMutation$data;
  variables: IntegrationWebFetcherCreateScreenWebFetcherMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "url"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "url",
            "variableName": "url"
          }
        ],
        "concreteType": "IntegrationWebFetch",
        "kind": "LinkedField",
        "name": "createIntegrationWebFetch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationWebFetcherCreateScreenWebFetcherMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationWebFetcherCreateScreenWebFetcherMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "eda6ec00949cd812586ce72c6f7118fd",
    "id": null,
    "metadata": {},
    "name": "IntegrationWebFetcherCreateScreenWebFetcherMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationWebFetcherCreateScreenWebFetcherMutation(\n  $url: String!\n) {\n  store {\n    createIntegrationWebFetch(url: $url) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6aa4739ba4e8dce305f0eef529553dce";

export default node;
